import { DOCUMENT } from '@angular/common';
import { Directive, inject, input } from '@angular/core';

import { RtTextInput } from '@core/user-interface-legacy';

import type { PlaceholderConfigMap } from './placeholder';

@Directive({
  selector: '[insertPlaceholderInput]',
  exportAs: 'placeholderInput',
  standalone: true,
})
export class InsertPlaceholderInputDirective {
  private readonly doc = inject<Document>(DOCUMENT);
  public readonly input = inject(RtTextInput, { host: true, self: true });

  public readonly placeholdersConfig = input<PlaceholderConfigMap>({});

  public insert(text: string): void {
    this.input.insertAtCaret(text, 'placeholder');
  }
}
